import { createRouter, createWebHistory } from 'vue-router';
import routes from 'vue-auto-routing';
import { createRouterLayout } from 'vue-router-layout';
import { tokenAPi } from '@/api/integrateapi/index';
import store from '@/store/index';
const RouterLayout = createRouterLayout(layout => {
  return import('@/layouts/' + layout + '.vue');
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: '/', redirect: '/managePaltform' },
    {
      path: '/',
      component: RouterLayout,
      children: routes,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/error/404',
    },
  ],
});

router.beforeEach(async (to, _, next) => {
  const { name: toName } = to;

  const token = store.getters.getTokenInfo;

  if (toName === 'login') {
    next();
    return;
  }

  if (!token) {
    alert('권한이 존재하지 않아 접근이 불가능 합니다. 로그인 후 이용해주세요.');
    window.open('https://www.carrotians.net', '_self');
    return;
  }

  const returnIsSuccess = await tokenAPi({
    token: token,
  })
    .then(resp => {
      const { success } = resp.data;
      return success;
    })
    .catch(err => {
      console.error('err : ', err);
      return false;
    });

  if (returnIsSuccess) {
    next();
    return;
  }

  alert('세션이 만료되었습니다.');
  store.commit('setMemberInfo', null);
  store.commit('setAccessToken', null);
  window.open('https://www.carrotians.net', '_self');
});

export default router;
